<!-- Body Section starts -->
<section class="container-fluid no-padding">
    <breadcrumb></breadcrumb>
</section>
<div>
    <div class="main ">
        <section class="admin-content">
            <div class="tab-content  custom-tab-content">
                <div class="view-users">
                    <div class="page-heading">
                        <span class="page-title">{{'order.Order Summary'| translate | translateKey}} </span>
                        <a class="backlink backuser-btn show">
                            <i class="fa fa-arrow-circle-left pad-r-8"></i>
                            <span [routerLink]="['/admin/customerservice/neworder']" tabindex="0" class="back-title"> {{'roles.Back to New Order' |translate}}</span>
                        </a>
                    </div>
                    <!--VIEW USER-->
                    <div class="title-underline"></div>
                    <div id="user-view" class="card col-xs-12 paddingbottom-10 show">

                        <div class="col-sm-8 col-md-12">
                            <div *ngIf="orderSession">
                                <ul class="col-sm-12 list-group orderdet-column clearfix" style="padding-right:0;list-style-type: none;">
                                    <li class="retail-list-group-item col-xs-12 col-md-7 list-style-colon">
                                        <div class="col-xs-12 profile-blocks">
                                            <div class="col-md-9">
                                                <!-- <div class="row">
                                                    <div class="heading-block col-xs-12">{{'customer-service.Order Information' |translate}}</div>
                                                </div> -->
                                                <div class="row">
                                                    <div class="col-xs-6 col-sm-4 col-md-5">
                                                        <label>{{'customer-service.Web Order Number' |translate}}</label>
                                                    </div>
                                                    <div class="col-xs-6 col-sm-6 col-md-7">
                                                        <ul>
                                                            <li>
                                                                {{webOrderId}}
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-xs-6 col-sm-4 col-md-5">
                                                        <label>{{'customer-service.Payment Status' |translate}}</label>
                                                    </div>
                                                    <div class="col-xs-6 col-sm-6 col-md-7">
                                                        <ul>
                                                            <li>
                                                                {{orderStatus}}
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-xs-6 col-sm-4 col-md-5">
                                                        <label>{{'customer-service.FBO ID' |translate}}</label>
                                                    </div>
                                                    <div class="col-xs-6 col-sm-6 col-md-7">
                                                        <ul>
                                                            <li>
                                                                {{orderSession.memberInfo?.fboId}}
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-xs-6 col-sm-4 col-md-5">
                                                        <label>{{'customer-service.Ordered By' |translate}}</label>
                                                    </div>
                                                    <div class="col-xs-6 col-sm-6 col-md-7">
                                                        <ul>
                                                            <li>
                                                                {{orderSession.memberInfo?.name}}
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>

                                                <!--Display Products Info -->
                                                <div style="margin-top: 10px;" class="row">
                                                    <div class="heading-block col-xs-12">{{'customer-service.Products Info' |translate}}</div>
                                                </div>
                                                <div style="margin-top: 10px;" class="profile-blocks">
                                                    <!-- <div class="heading-block text-decoration-none">{{'customer-service.Products Info' |translate}}
                                                    </div> -->
                                                    <div class="custyle">
                                                        <table class="table table-striped custab">
                                                            <thead>
                                                                <tr>
                                                                    <th>{{'customer-service.Product Info' |translate}}
                                                                    </th>
                                                                    <th>{{'customer-service.Unit Price' |translate}}
                                                                    </th>
                                                                    <th>{{'customer-service.Quantity' |translate}}
                                                                    </th>
                                                                    <th>{{'customer-service.Sub Total' |translate}}
                                                                    </th>
                                                                    <th *ngIf="orderSession.memberInfo.memberTypeId!=6">{{'customer-service.Total CC' |translate}}
                                                                    </th>
                                                                </tr>
                                                            </thead>
                                                            <tbody *ngIf="orderSession.products">
                                                                <tr class="orderhistory-tr" *ngFor="let item of orderSession.products">
                                                                    <td>{{item.name}}</td>
                                                                    <td>{{item.applicablePrice | currencyFormat:orderSession.storeInfo:true:false}}</td>
                                                                    <td>{{item.quantity}}</td>
                                                                    <td class="text-right">{{(item.applicablePrice * item.quantity) | currencyFormat:orderSession.storeInfo:true:false}}</td>
                                                                    <td *ngIf="orderSession.memberInfo.memberTypeId!=6">{{(item.commissionableVolume * item.quantity)| ccFormat:orderSession.storeInfo:false}}</td>

                                                                </tr>
                                                            </tbody>


                                                        </table>
                                                    </div>

                                                </div>
                                                <!--Shipping Info -->
                                                <div style="margin-top: 10px;" class="row">
                                                    <div class="heading-block col-xs-12">{{'customer-service.Shipping & Payment Info' |translate}}</div>
                                                </div>

                                                <div class="margintop-10">

                                                    <div class="list-group-item">

                                                        <div class="row">
                                                            <div class="col-md-5">
                                                                <label>{{'order.Delivery Preference' |translate}}</label>
                                                            </div>
                                                            <div class="col-md-7">
                                                                : &nbsp; {{orderSession.deliveryPreference===1?'Delivery':'Pickup'}}

                                                            </div>
                                                        </div>
                                                        <div class="row">
                                                            <div class="col-md-5">
                                                                <label>{{orderSession.deliveryPreference===1 ? 'Shipping Address':'Pickup Address' }}</label>
                                                            </div>
                                                            <div class="col-md-7" style="overflow-wrap: break-word;">
                                                                <!-- : &nbsp; {{memberInfo?.email}} -->
                                                                <div *ngIf="orderSession.deliveryPreference===1">
                                                                    <div>
                                                                        : &nbsp;
                                                                        <b> {{orderSession.shippingAddress?.shipToName}}</b>
                                                                    </div>
                                                                    <div>
                                                                        {{orderSession.shippingAddress?.addressLine1}} , {{orderSession.shippingAddress?.addressLine2}}
                                                                    </div>
                                                                    <div>
                                                                        {{orderSession.shippingAddress?.city}}, {{orderSession.shippingAddress?.stateCode}} , {{orderSession.shippingAddress?.postalCode}}
                                                                    </div>
                                                                    <div>
                                                                        {{orderSession.shippingAddress?.countryName}}
                                                                    </div>
                                                                </div>
                                                                <div *ngIf="orderSession.deliveryPreference===2">
                                                                    <div>
                                                                        <b>{{orderSession.shipMethod.pickUpLocation.pickupCenterName}}</b>
                                                                    </div>
                                                                    <div>{{orderSession.shipMethod.pickUpLocation.addressLine1
                                                                        }} {{ orderSession.shipMethod.pickUpLocation.addressLine1}}</div>
                                                                    <div>{{orderSession.shipMethod.pickUpLocation.city }} {{ orderSession.shipMethod.pickUpLocation.state}}
                                                                    </div>
                                                                    <div>{{orderSession.shipMethod.pickUpLocation.zip }} {{ orderSession.shipMethod.pickUpLocation.country}}
                                                                    </div>
                                                                </div>

                                                                <div class="" *ngIf="orderSession.deliveryPreference===1">
                                                                    {{'ordersummary.This product will ship via' | translate | translateKey}}:
                                                                </div>
                                                                <div *ngIf="orderSession.deliveryPreference===1">
                                                                    <b>
                                                                        <span *ngIf="orderSession.shipMethod">
                                                                            {{orderSession.shipMethod.shippingCarrier +' -'}}
                                                                        </span>
                                                                        <span>
                                                                            {{orderSession.shipMethod.shippingMethod}}
                                                                        </span>
                                                                    </b>
                                                                </div>

                                                            </div>
                                                        </div>
                                                        <div class="row margintop-10">
                                                            <div class="col-md-5">
                                                                <label>{{'order.Payment Info' |translate}}</label>
                                                            </div>
                                                            <div class="col-md-7" style="overflow-wrap: break-word;">

                                                                <div>
                                                                    : &nbsp;
                                                                    <b> {{'checkout.Credit / Debit Card' | translate | translateKey}}</b>
                                                                </div>
                                                                <div class="{{orderSession.paymentInfo.cardType}} cc-number card-type">
                                                                    <span> {{'checkout.ending in' | translate | translateKey}} {{orderSession.paymentInfo.maskedNumner.substr(orderSession.paymentInfo.maskedNumner.length
                                                                        - 4)}}
                                                                    </span>
                                                                </div>
                                                                <div class="">
                                                                    <span> {{orderSession.paymentInfo.userCardHolderName}} </span>
                                                                </div>
                                                                <div>{{'checkout.Valid Thru' | translate | translateKey}}: {{orderSession.paymentInfo.cardExpirationMonth}}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </li>
                                    <li>
                                        <div class="col-md-3">
                                            <div class="row">
                                                <div class="heading-block col-xs-12">{{'customer-service.Order Summary' |translate}}</div>
                                            </div>
                                            <div class="row">
                                                <div class="col-md-8">
                                                    <label>{{'customer-service.Sub Total' |translate}}</label>
                                                </div>
                                                <div class="col-md-4">
                                                    <div> : &nbsp; {{orderSession.orderSubTotal | currencyFormat:orderSession.storeInfo:true:false}}
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-md-8">
                                                    <label>{{'customer-service.Shipping & Handling' |translate}}</label>
                                                </div>
                                                <div class="col-md-4">
                                                    <div> : &nbsp; {{orderSession.orderShippingCost| currencyFormat:orderSession.storeInfo:true:false}}
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-md-8">
                                                    <label>{{'customer-service.Tax' |translate}}</label>
                                                </div>
                                                <div class="col-md-4">
                                                    <div> : &nbsp; {{orderSession.orderTax| currencyFormat:orderSession.storeInfo:true:false}}
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row" *ngIf="orderSession.importFeeValue">
                                                <div class="col-md-8">
                                                    <label>{{'customer-service.Fees' |translate}}</label>
                                                </div>
                                                <div class="col-md-4">
                                                    <div> : &nbsp; {{orderSession.importFeeValue | currencyFormat:orderSession.storeInfo:true:false}}
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row" style=" border-top: 1px solid #ddd; border-bottom: 1px solid #ddd; ">
                                                <div class="col-md-8">

                                                    <label>
                                                        <b>{{'customer-service.Total' |translate}}</b>
                                                    </label>

                                                </div>
                                                <div class="col-md-4">
                                                    <b>
                                                        <div> : &nbsp; {{orderSession.orderTotal| currencyFormat:orderSession.storeInfo:true:false}}
                                                        </div>
                                                    </b>
                                                </div>
                                                <div *ngIf="orderSession.memberInfo.memberTypeId!=6" class="col-md-8">

                                                    <label>
                                                        <b>{{'customer-service.Total CC' |translate}}</b>
                                                    </label>

                                                </div>
                                                <div *ngIf="orderSession.memberInfo.memberTypeId!=6" class="col-md-4">
                                                    <b>
                                                        <div> : &nbsp; {{orderSession.orderTotalCC| ccFormat:orderSession.storeInfo:false}}
                                                        </div>
                                                    </b>
                                                </div>
                                            </div>
                                        </div>

                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/views/order-promotion-summary.html